//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import dummyItem from '~/components/content/dummy/video_dummy.vue';
import ImageSrcsetMixin from '~/mixins/ImageSrcsetMixin';
export default {
  mixins: [ImageSrcsetMixin],
  data() {
    return {
      gallery: true,
      index: null,
      ratio: 'videoratio',
    };
  },
  components: {
    dummyItem,
  },
  mounted() {
    const prevButton = document.querySelector('.blueimp-gallery > .prev');
    const nextButton = document.querySelector('.blueimp-gallery > .next');
    if (prevButton && nextButton) {
      prevButton.textContent = '';
      nextButton.textContent = '';
    }
  },
  computed: {
    ...mapState({
      video: ({ resourcesStore: { video } }) => video,
      loading: ({ resourcesStore: { loading } }) => loading,
    }),
    galleryImages() {
      if (!this.video.images || !this.video.images.data.album) {
        return [];
      }
      return this.video.images.data.album.map(image => this.$config.cdn + image.path);
    }

  },
};
